import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_SECONDARY_BRAND_ALLOCATION, ROUTE_SECONDARY_DR_LEVEL_BRAND_ALLOCATION} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const SecondaryDrLevelBrandAllocation = lazy(() =>
  import('../../../screens/SecondaryDrLevelBrandAllocation')
    .then(module => ({default: module.SecondaryDrLevelBrandAllocation})));

const SecondaryDrLevelBrandAllocationNavigation = [
  {
    path: ROUTE_SECONDARY_DR_LEVEL_BRAND_ALLOCATION,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryDrLevelBrandAllocation />
      </Suspense>
    ),
  },
];

export default SecondaryDrLevelBrandAllocationNavigation;
